/**
 * TechAssembly / Phoenix-theme style tokens backed by CSS custom properties.
 *
 * Use these instead of hardcoded hex values so the serverless React frontend
 * stays aligned with the Phoenix Tailwind token set and responds to dark mode
 * automatically.
 */

export const tokens = {
  // Text
  foreground: 'var(--text-primary)',
  muted: 'var(--text-secondary)',
  subtle: 'var(--text-tertiary)',

  // Accent / CTA
  accent: 'var(--accent)',
  accentSubtle: 'var(--accent-subtle)',
  accentText: 'var(--accent-text)',
  ctaBg: 'var(--cta-primary)',
  ctaText: 'var(--cta-primary-text)',

  // Surfaces
  surface: 'var(--surface-elevated)',
  surfaceSecondary: 'var(--surface-secondary)',
  appBg: 'var(--surface-primary)',
  overlay: 'var(--surface-overlay)',

  // Borders
  border: 'var(--border-primary)',
  borderSecondary: 'var(--border-secondary)',

  // Status
  successBg: 'var(--status-success-bg)',
  successBorder: 'var(--status-success-border)',
  successText: 'var(--status-success-text)',
  errorBg: 'var(--status-error-bg)',
  errorBorder: 'var(--status-error-border)',
  errorText: 'var(--status-error-text)',
  warning: 'var(--status-warning)',
  warningBg: 'var(--status-warning-bg)',
  info: 'var(--status-info)',
  infoBg: 'var(--status-info-bg)',
} as const;

export type StyleToken = (typeof tokens)[keyof typeof tokens];
